import { Router } from "@solidjs/router";
import { FileRoutes } from "@solidjs/start/router";
import { ErrorBoundary, Suspense, onMount } from "solid-js";

import Nav from "~/components/Nav";
import "./app.css";
import "flowbite";

import { Link, MetaProvider, Title } from "@solidjs/meta";
import posthog from "posthog-js";
import { getGlobalConfig } from "./lib/config-global";
import { track } from "./lib/customer-io";

export default function App() {
  onMount(() => {
    // Initialize Customer.io at runtime to avoid bundling secrets
    const config = getGlobalConfig();

    // Create and execute Customer.io script dynamically at runtime
    const script = document.createElement("script");
    script.innerHTML = `
      var _cio = _cio || [];
      (function() {
        var a,b,c;a=function(f){return function(){_cio.push([f].
        concat(Array.prototype.slice.call(arguments,0)))}};b=["load","identify",
        "sidentify","track","page"];for(c=0;c<b.length;c++){_cio[b[c]]=a(b[c])};
        var t = document.createElement('script'),
            s = document.getElementsByTagName('script')[0];
        t.async = true;
        t.id    = 'cio-tracker';
        t.setAttribute('data-site-id', '${config.customerIO.trackAPI.siteID}');
        t.src = 'https://assets.customer.io/assets/track-eu.js';
        s.parentNode.insertBefore(t, s);
      })();
    `;
    document.head.appendChild(script);

    posthog.init("phc_Io7VIiZPYuCZZQndnqXiO3eJLvRgaDj7MjuOaDmV1pV", {
      api_host: "https://eu.i.posthog.com",
    });
  });

  // making an arbitrary change to test sentry deploy config
  return (
    <ErrorBoundary
      fallback={(error) => {
        console.error("Application error:", error);
        track("client-error-occured", {
          handled: false,
          error_message: error.message,
          error_stack: error.stack,
        });

        return <p>An error has occured, and was logged.</p>;
      }}
    >
      <Router
        root={(props) => (
          <>
            <MetaProvider>
              <Title>Fun Fun Function</Title>

              <Link
                rel="apple-touch-icon"
                sizes="180x180"
                href="/apple-touch-icon.png"
              />
              <Link
                rel="icon"
                type="image/png"
                sizes="32x32"
                href="/favicon-32x32.png"
              />
              <Link
                rel="icon"
                type="image/png"
                sizes="16x16"
                href="/favicon-16x16.png"
              />
              <Link rel="manifest" href="/site.webmanifest"></Link>

              <Suspense>{props.children}</Suspense>

              <footer class="fixed bottom-0 left-0 right-0 text-center text-xs text-teal-100 py-1 opacity-70 hover:opacity-100">
                Fun Fun Function AB * Tjärhovsgatan 52 * Stockholm, Stockholm 11628 * <a href="/privacy">Privacy Policy</a>
              </footer>
            </MetaProvider>
          </>
        )}
      >
        <FileRoutes />
      </Router>
    </ErrorBoundary>
  );
}
